module.exports = __webpack_public_path__ + "static/media/logo-white.e2926b66.png";